module.exports = __webpack_public_path__ + "static/media/CloudCards.5fa0d924.JPG";